/**
 * Der Weg des Buchungsstapels nach DATEV. Eigene Anleitung neben
 * DatevAnleitung.tsx, die fuer camt und MT940 unveraendert bleibt.
 * Text aus dem alten Kartenstand (DatevAnleitung, Format datev_extf),
 * ergaenzt um den Menuepfad fuer den ASCII-Import.
 */
export function KartenAnleitung() {
  return (
    <ol className="anleitung">
      <li>Die Datei ist ein Buchungsstapel im DATEV-Format. Sie wird in <b>DATEV Rechnungswesen</b> beim Mandanten eingelesen, nicht über die Kontenverwaltung.</li>
      <li>Im Mandantenbestand <b>Bestand | Importieren | ASCII-Daten</b>, als Art <b>Buchungsstapel</b> wählen und die .csv-Datei auswählen. Ein ZIP vorher entpacken, jede Datei einzeln einlesen.</li>
      <li>Beraternummer, Mandantennummer und Beginn des Wirtschaftsjahres stehen im Kopf der Datei. Je Karte und Wirtschaftsjahr entsteht eine eigene Datei.</li>
      <li>Die Festschreibung bleibt aus. Die Buchungen lassen sich nach dem Import prüfen und ändern.</li>
      <li>Gebucht wird Kartenkonto an Gegenkonto (Interimskonto). Der Ausgleich vom Girokonto steht auch auf dem Kontoauszug, dort bitte nicht doppelt buchen. Die Belege werden danach zugeordnet.</li>
      <li className="leiser">Quelle: DATEV Developer Portal, DATEV-Format Buchungsstapel, Formatversion 13.</li>
    </ol>
  )
}
